export const isAltDev = process.env.REACT_APP_ALT_DEV === '1';

export const isLocalDev = process.env.NODE_ENV === 'development';

export const isStaging =
  process.env.REACT_APP_SENTRY_ENVIRONMENT === 'staging' ||
  process.env.REACT_APP_SITE_URL?.includes('staging.endchess.com') === true;
